module.exports = __webpack_public_path__ + "img/k3.d1e1b4b0.png";